module.exports = __webpack_public_path__ + "img/guide_shipping.aec39956.svg";